import {
  REQUEST_CAMPAIGN_LIST,
  REQUEST_FILTERED_CAMPAIGN_LIST,
  REQUEST_CAMPAIGN
} from './mutation-types';

export default {
  [REQUEST_CAMPAIGN_LIST] (state, receivedData) {
    state.campaigns = receivedData.content;
    state.campaignCount = receivedData.totalElements;
  },
  [REQUEST_FILTERED_CAMPAIGN_LIST] (state, receivedData) {
    state.filteredCampaigns = receivedData;
  },
  [REQUEST_CAMPAIGN] (state, receivedData) {
    state.campaign = receivedData
  }
}